import { SET_DRIVER } from "../../types";

const INITIAL_STATE = {};

const driver = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_DRIVER:
      return {
        ...state,
        driver: action.driver,
      };
    default:
      return state;
  }
};

export default driver;
